// import { configureStore } from '@reduxjs/toolkit';
// import userReducer from './usersSlice';


// const store = configureStore({

//   reducer: {
//     user: userReducer,  
//   },
// });



// export default store;

import { configureStore } from '@reduxjs/toolkit';
import usersReducer from './usersSlice';

import storage from 'redux-persist/lib/storage'; // defaults to localStorage
import { persistReducer, persistStore } from 'redux-persist';
import { combineReducers } from 'redux';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user'] // only persist the 'users' slice
};

const rootReducer = combineReducers({
  user: usersReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // redux-persist uses non-serializable values
    }),
});

export const persistor = persistStore(store);
